import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { DropDownList } from "../core/components/dropDownList.js";
import { FieldInstance } from "../core/components/field.js";
import { TextBox } from "../core/components/textBox.js";
import { CheckBox } from "../core/components/checkBox.js";
import { Button } from "../core/components/button.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { ToggleButtonGroup } from "../core/components/toggleButtonGroup.js";
import { Helper } from "../core/util/helper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Config } from "../core/config/config.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { ResourcePlanningSchedulerSettingsViewModel } from "./resourcePlanningScheduler.js";
import { FavoriteFilterHelper, FavoriteFilterSheetResult } from "../favoriteFilter/editFavoriteFilter.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import React from "react";
import ReactDOM from "react-dom";

export class FavoriteFilterManager extends React.Component<FavoriteFilterManagerProps, FavoriteFilterManagerState>{
    private factory = ComponentHelper.createFactory();
    private scheduler = (window["dps"] as DayPilot.Scheduler);
    private locked = false;

    constructor(props: FavoriteFilterManagerProps) {
        super(props);
        this.state = {
            dataSource: null,
            selected: null,
            settings: JSON.parse(JSON.stringify(props.settings)),
            editModeEnabled: false
        }
        this.initApp();
    }

    private initApp = async () => {
        await this.loadData();

        let defaultFavoriteFilter: FavoriteFilter;
        if (!Helper.isNullOrEmpty(this.props.favoriteFilterId)) {
            defaultFavoriteFilter = this.state.dataSource.find(ff => ff.Id == this.props.favoriteFilterId);
        } else {
            defaultFavoriteFilter = this.state.dataSource.find(ff => ff.IsDefault);
        }
        this.setState({ selected: defaultFavoriteFilter })
    }

    private loadData = (busyIndicatorOn: boolean = true) => {
        return new Promise<void>(async (resolve) => {
            const url = "FavoriteFilter/GetAllForUser";
            let promise: Promise<JsonResultClass<FavoriteFilter[]>>;
            if (busyIndicatorOn) {
                promise = HTTPService.get<JsonResultClass<FavoriteFilter[]>>(url);
            } else {
                promise = HTTPService.noBusyIndicator().get<JsonResultClass<FavoriteFilter[]>>(url);
            }
            const result = await promise;
            if (result.Code == 0) {
                this.setState({ dataSource: result.Data }, resolve);
            }
        })
    }

    private setValue = async (favorite: FavoriteFilter) => {
        let settings: ResourcePlanningSchedulerSettingsViewModel = null;
        const id = Helper.hasValue(favorite) ? favorite.Id : null;
        const result = await HTTPService.post<JsonResultClass<ResourcePlanningSchedulerSettingsViewModel>>("FavoriteFilter/LoadSettings", {
            id: id,
            start: this.scheduler.startDate
        });
        if (result.Code == 0) {
            settings = result.Data;
            if (!Helper.hasValue(id)) {
                const ds: ResourcePlanningSchedulerSettingsViewModel = Helper.loadDataFromStorage("resourcePlanningScheduler_DisplaySettings");
                if (Helper.hasValue(ds)) {
                    settings.AssignmentMoveHorizontalFixed = ds.AssignmentMoveHorizontalFixed;
                    settings.AssignmentMoveVerticalFixed = ds.AssignmentMoveVerticalFixed;
                    settings.AutoUpdateScheduler = ds.AutoUpdateScheduler;
                    settings.DisplayCapacityChart = ds.DisplayCapacityChart;
                    settings.DisplayGeomapMap = ds.DisplayGeomapMap;
                    settings.DisplayWorkListInTable = ds.DisplayWorkListInTable;
                    settings.FlagMode = ds.FlagMode;
                    settings.GroupByAddresses = ds.GroupByAddresses;
                    settings.GroupByMachines = ds.GroupByMachines;
                    settings.GroupByProjects = ds.GroupByProjects;
                    settings.GroupByResources = ds.GroupByResources;
                    settings.ShowAssignmentsWithTimeZones = ds.ShowAssignmentsWithTimeZones;
                    settings.ShowDegreeOfCompletion = ds.ShowDegreeOfCompletion;
                    settings.ShowOnlyWorktime = ds.ShowOnlyWorktime;
                    settings.ShowProjectColor = ds.ShowProjectColor;
                    settings.ShowTargetPeriods = ds.ShowTargetPeriods;
                    settings.ShowUtilization = ds.ShowUtilization;
                    settings.WholeDayAssignmentRendering = ds.WholeDayAssignmentRendering;
                    settings.SlaViewActive = ds.SlaViewActive;
                    settings.ResourceFilterExclusive = ds.ResourceFilterExclusive;
                    settings.CapacityIgnoreProjectFilter = ds.CapacityIgnoreProjectFilter;
                    settings.ProjectFilterShowAllAssignments = ds.ProjectFilterShowAllAssignments;

                    const fitToScreen: boolean = Helper.loadDataFromStorage("timeSpanManager_fitToScreen");
                    if (Helper.hasValue(fitToScreen)) {
                        settings.FixedCellWidth = !fitToScreen;
                    } else {
                        settings.FixedCellWidth = false;
                    }
                }

            }
            this.locked = true;
            settings.ActiveExtendedProjectFilter = this.props.settings.ActiveExtendedProjectFilter;
            this.setState({ selected: favorite, settings: JSON.parse(JSON.stringify(settings)) }, () => {
                this.props.onChange(settings);
                this.locked = false;
            })
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private renderDropDown = () => {
        if (!Helper.hasValue(this.state.dataSource) || this.state.dataSource.length === 0) {
            return (
                <label style={{ fontSize: "13px" }}>
                    {Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.NoFiltersAvaiable")}
                </label>
            );
        }
        let props = this.factory.getDefaultDropDownProps();
        props.dataSource = this.state.dataSource;
        props.value = Helper.hasValue(this.state.selected) ? this.state.selected.Id : null;
        props.field.dataTextField = "Name";
        props.field.dataValueField = "Id";
        props.field.refreshDSOnRefChange = true;
        props.field.listWidth = 200;
        props.field.template = "<div style='display: flex; align-items: center'><label>${data.Name}</label>#if(data.IsDefault){#<div style='margin: 0 0 0 5px'><i class='fal fa-star fa-lg'></div></i>#} if(data.IsGlobal){#<div style='margin: 0 0 0 5px'><i class='fal fa-globe-europe fa-lg'></div></i>#}#</div>"
        props.disabled = this.state.editModeEnabled;
        props.onChange = (_, value: string, dataItem: FavoriteFilter) => {
            if (Helper.isNullOrEmpty(value)) {
                dataItem = null;
            }
            this.setValue(dataItem).then();
        }
        return (
            <div style={{ width: "150px" }}>
                <DropDownList {...props} />
            </div>
        );
    }

    private renderButtons = () => {
        const newButton = (
            <>
                <div title={Helper.getTranslation("Standard.Neu")} >
                    <Button
                        handleClick={this.createNewFavorite}
                        readOnly={this.state.editModeEnabled}
                        iconName={"plus"}
                    />
                </div >
            </>
        );
        let defaultButton = null;
        let editButton = null;
        let deleteButton = null;
        let editModeButton = null;
        if (Helper.hasValue(this.state.selected)) {
            if (!this.state.selected.IsDefault) {
                defaultButton = (
                    <>
                        <div title={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.Default")} >
                            <Button
                                handleClick={this.setNewDefault}
                                readOnly={this.state.editModeEnabled}
                                iconName={"star"}
                            />
                        </div >
                    </>
                );
            } else {
                defaultButton = (
                    <>
                        <div title={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.DeDefault")} >
                            <Button
                                handleClick={this.removeDefault}
                                readOnly={this.state.editModeEnabled}
                                layerIcons={[{ name: "star", attributes: ["stack-1x"] }, { name: "ban", attributes: ["stack-1x"], style: { fontSize: "1.5em" } }]}
                                iconStyle={{ display: "flex" }}
                                buttonStyle={{ width: "38px", padding: "0" }}
                            />
                        </div >
                    </>
                );
            }
            if (!this.state.selected.IsGlobal || Config.user.isSysAdmin) {
                editButton = (
                    <>
                        <div title={Helper.getTranslation("Standard.Editieren")} >
                            <Button
                                handleClick={this.editFavoriteFilter}
                                readOnly={this.state.editModeEnabled}
                                iconName={"cog"}
                            />
                        </div >
                    </>
                );

                if (this.state.editModeEnabled) {
                    editModeButton = (
                        <>
                            <div title={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.SaveChanges")} >
                                <Button
                                    handleClick={() => { this.toggleEditMode(false) }}
                                    readOnly={false}
                                    iconName={"check"}
                                />
                            </div >
                        </>
                    );
                } else {
                    editModeButton = (
                        <>
                            <div title={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.ActiveEditMode")} >
                                <Button
                                    handleClick={() => { this.toggleEditMode(true) }}
                                    readOnly={false}
                                    iconName={"pen"}
                                />
                            </div >
                        </>
                    );
                }


            }
            if (!this.state.selected.IsGlobal) {
                deleteButton = (
                    <>
                        <div title={Helper.getTranslation("Standard.Loeschen")} >
                            <Button
                                handleClick={this.deleteFavoriteFilter}
                                readOnly={this.state.editModeEnabled}
                                iconName={"trash-alt"}
                            />
                        </div >
                    </>
                );
            }
        }
        return (
            <>
                <div style={{ marginLeft: "5px", display: "flex" }} className="favorite-filter-manager_buttons">
                    {newButton}
                    {defaultButton}
                    {editModeButton}
                    {editButton}
                    {deleteButton}
                </div>
            </>
        );
    }

    private toggleEditMode = (toggle: boolean) => {
        const key = toggle ? "WebSMS.ResourcePlanningScheduler.Favorite.EditModeOn" : "WebSMS.ResourcePlanningScheduler.Favorite.EditModeOff";
        NotificationHelper.showInfoMessage(Helper.getTranslation(key));
        this.locked = toggle;
        let settings = this.state.settings;
        if (!toggle)
            settings = JSON.parse(JSON.stringify(this.props.settings))
        this.setState({ editModeEnabled: toggle, settings: settings })
    }

    private createNewFavorite = async () => {

        const validateName = (name: string) => {
            if (Helper.isNullOrEmpty(name)) {
                NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.InsertName"));
                return false;
            }
            if (this.state.dataSource.findIndex(f => f.Name.trim().toLowerCase() === name.trim().toLowerCase()) > -1) {
                NotificationHelper.showWarningMessage(Helper.getTranslation("Skills.NameAssign"));
                return false;
            }

            if (name.length > 128) {
                NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.NameToLong"));
                return false;
            }
            return true;
        }
        const [name, createAsGlobal] = await FavoriteFilterManagerHelper.getUserSettings(validateName);
        const newItem = await FavoriteFilterManagerHelper.create(name as string, createAsGlobal as boolean, this.props.settings)
        let dataSource: FavoriteFilter[] = JSON.parse(JSON.stringify(this.state.dataSource));
        dataSource.push(newItem);
        dataSource = dataSource.sort(this.sortByAlphabet);
        this.setState({ dataSource: dataSource }, () => {
            this.setValue(newItem);
        })
    }

    private saveFavorite = async () => {
        try {
            await FavoriteFilterManagerHelper.save(this.state.selected.Id, this.props.settings);
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"));
        } catch (reason) {
            NotificationHelper.showErrorMessage(reason);
        }
    }

    private removeDefault = async () => {
        const result = await HTTPService.get<JsonResultClass>("FavoriteFilter/RemoveDefault");
        if (result.Code == 0) {
            await this.loadData(false);
            this.setState({ selected: this.state.dataSource.find(f => f.Id === this.state.selected.Id) })
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private setNewDefault = async () => {
        const result = await HTTPService.get<JsonResultClass>(`FavoriteFilter/SetDefault?id=${this.state.selected.Id}&type=${AffilationType.User}&entityId=${Config.user.userName}`);
        if (result.Code == 0) {
            await this.loadData(false);
            this.setState({ selected: this.state.dataSource.find(f => f.Id === this.state.selected.Id) })
            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.NewDefault").replace("{name}", this.state.selected.Name));
        }
    }

    private deleteFavoriteFilter = async () => {
        const ok = await DialogHelper.confirm(__internal_translations["Standard.Msg.Loeschen"]);
        if (ok) {
            await FavoriteFilterHelper.delete(this.state.selected.Id);
            const dataSource = this.state.dataSource.filter(f => f.Id != this.state.selected.Id);
            this.setState({ dataSource: dataSource }, () => {
                this.setValue(null);
            });
        }
    }

    private editFavoriteFilter = async () => {
        try {
            const id = this.state.selected.Id;
            const result = await FavoriteFilterHelper.editFavorite(id, this.state.selected.IsGlobal);
            switch (result) {
                case FavoriteFilterSheetResult.JustClosed:
                    this.props.onChange(null);
                    break;
                case FavoriteFilterSheetResult.SavedSuccessfully:
                    await this.loadData();
                    const currentFilter = this.state.dataSource.find(f => f.Id == this.state.selected.Id);
                    await this.setValue(currentFilter);
                    break;
                case FavoriteFilterSheetResult.DeletedSuccessfully:
                    const dataSource = this.state.dataSource.filter(f => f.Id != id)
                    this.setState({ selected: null, dataSource: dataSource });
                    break;
            }
        } catch (reason) {
            NotificationHelper.showErrorMessage(reason);
        }
    }

    private sortByAlphabet = (a: FavoriteFilter, b: FavoriteFilter) => {
        if (a.Name < b.Name) {
            return -1;
        }
        if (a.Name > b.Name) {
            return 1;
        }
        return 0;
    }

    componentDidUpdate(_: any, prevState: FavoriteFilterManagerState) {
        if (!this.state.editModeEnabled && prevState.editModeEnabled) {
            this.saveFavorite().then();
        } else if (!this.locked && Helper.hasValue(this.state.selected) && (this.getHashCode(this.state.selected) == this.getHashCode(prevState.selected))) {
            const isSame = FavoriteFilterManagerHelper.compareSettings(this.props.settings, this.state.settings);
            if (!isSame) {
                const newSettings: ResourcePlanningSchedulerSettingsViewModel = JSON.parse(JSON.stringify(this.props.settings));
                newSettings.FavoriteFilterId = null;
                this.setState({ selected: null, settings: newSettings }, () => {
                    this.props.onChange(newSettings);
                })
            }
        }
        Helper.saveDataToStorage("current_favorite_filter", this.state.selected, false);
    }

    private getHashCode = (ff: FavoriteFilter) => {
        if (!Helper.hasValue(ff))
            return 0;
        let hash = 17;
        hash = hash * 23 + Helper.getHashCode(ff.Id);
        hash = hash * 23 + Helper.getHashCode(ff.IsDefault ? "1" : "0");
        hash = hash * 23 + Helper.getHashCode(ff.IsGlobal ? "1" : "0");
        return hash;
    }

    render() {
        return (
            <ToggleButtonGroup style={{ margin: "0 10px 10px 0", display: "flex", alignItems: "center", flexDirection: "row-reverse" }}>
                {this.renderButtons()}
                {this.renderDropDown()}
            </ToggleButtonGroup >
        );
    }
}

interface FavoriteFilterManagerProps {
    settings: ResourcePlanningSchedulerSettingsViewModel;
    onChange: (settings: ResourcePlanningSchedulerSettingsViewModel) => void;
    favoriteFilterId: string;
}

interface FavoriteFilterManagerState {
    dataSource: FavoriteFilter[];
    selected: FavoriteFilter;
    settings: ResourcePlanningSchedulerSettingsViewModel;
    editModeEnabled: boolean;
}

export interface FavoriteFilter {
    Id: string;
    Name: string;
    IsDefault: boolean;
    IsGlobal: boolean;
}

class FavoriteFilterManagerHelper {

    public static throwNotImplemented = () => {
        NotificationHelper.showWarningMessage("Not implemented")
    }

    public static create = (name: string, createAsGlobal: boolean, settings: ResourcePlanningSchedulerSettingsViewModel) => {
        return new Promise<FavoriteFilter>(async (resolve, reject) => {
            const options: FavoriteFilterCreationOptions = {
                CellWidth: window["dps"].cellWidth,
                Fallbackname: name,
                SchedulerSettings: settings,
                CreateAsGlobal: createAsGlobal
            };
            const result = await HTTPService.post<JsonResultClass<FavoriteFilter>>("FavoriteFilter/Create", {
                options: options
            });
            if (result.Code === 0) {
                NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"));
                resolve(result.Data);
            }
            reject();
        })
    }

    public static getUserSettings = (validateName: (name: string) => boolean) => {
        return new Promise<(string | boolean)[]>((resolve, reject) => {
            const targetElement = $("<div>");
            $("body").append(targetElement);
            ReactDOM.render(
                <FavoriteFilterManagerDialog
                    onClose={reject}
                    onOk={(name, createAsGlobal) => {
                        const arr: (string | boolean)[] = [
                            name,
                            createAsGlobal
                        ];
                        resolve(arr);
                    }}
                    validateName={validateName}
                />,
                targetElement[0]
            );
        })
    }

    public static delete = (id: string) => {
        return new Promise<boolean>(async (resolve, _) => {
            const result = await HTTPService.get<JsonResultClass>(`FavoriteFilter/Delete?id=${id}`);
            resolve(result.Code === 0);
        })
    }

    public static save = (id: string, settings: ResourcePlanningSchedulerSettingsViewModel) => {

        debugger;

        return new Promise<void>(async (resolve, reject) => {
            const options: FavoriteFilterSavingOptions = {
                CellWidth: window["dps"].cellWidth,
                SchedulerSettings: settings,
                Id: id
            };
            const result = await HTTPService.post<JsonResultClass<FavoriteFilter>>("FavoriteFilter/Save", {
                options: options
            });
            if (result.Code === 0) {
                resolve();
            } else {
                reject(result.Message);
            }
        })
    }

    public static compareSettings = (a: ResourcePlanningSchedulerSettingsViewModel, b: ResourcePlanningSchedulerSettingsViewModel) => {
        const ignoredKeys = ["Flags", "GeomapFilterRouteResultGraduation", "AllWeekendDays", "Start", "End", "DoNotChangeCellWidth", "SendStates", "AssignmentSorting"];
        const keys = Object.keys(a).filter(key => ignoredKeys.findIndex(f => f.toLowerCase() == key.toLowerCase()) == -1);
        let result = true;
        keys.forEach((key) => {

            switch (typeof a[key]) {
                case 'bigint':
                case 'boolean':
                case 'number':
                case 'string':
                    if (a[key] != b[key]) {
                        result = false;
                    }
                    break;
                case 'object':
                    if (Array.isArray(a[key]) && !FavoriteFilterManagerHelper.compareLists(a[key], b[key])) {
                        result = false;
                    }
                    break;
            }
        });
        return result;
    }

    private static compareLists = (a: Array<any>, b: Array<any>) => {
        const bSorted = b.slice().sort();
        return a.length === b.length && a.slice().sort().every(function (value, index) {
            return value === bSorted[index];
        });
    }

}

enum AffilationType {
    User = 0,
    Group = 1,
    MainGroup = 2
}

interface FavoriteFilterCreationOptions {
    Fallbackname: string;
    SchedulerSettings: ResourcePlanningSchedulerSettingsViewModel;
    CellWidth: number;
    CreateAsGlobal: boolean;
}

interface FavoriteFilterSavingOptions {
    Id: string;
    SchedulerSettings: ResourcePlanningSchedulerSettingsViewModel;
    CellWidth: number;
}

class FavoriteFilterManagerDialog extends React.Component<FavoriteFilterManagerDialogProps, { name: string, createAsGlobal: boolean }>{
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.CreateNewFilter"),
        width: 500,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.props.onClose();
                },
            },
            {
                label: Config.translations.ok,
                action: () => {
                    const isValid = this.props.validateName(this.state.name);
                    if (!isValid)
                        return false;
                    this.props.onOk(this.state.name, this.state.createAsGlobal);
                },
                primary: true
            }
        ]
    };

    constructor(props: FavoriteFilterManagerDialogProps) {
        super(props);
        this.state = {
            createAsGlobal: false,
            name: ""
        }
    }

    private renderTextbox = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.name;
        props.onChange = (_, value: string) => {
            this.setState({ name: value })
        }

        return (
            <FieldInstance label={Helper.getTranslation("Field.Ressource.name")} labelLabelStyle={{ width: "150px" }}>
                <TextBox {...props} />
            </FieldInstance>
        );

    }

    private renderCheckbox = () => {
        const props = this.factory.getDefaultCheckBoxProps();
        props.value = this.state.createAsGlobal;
        props.onChange = (_, value: boolean) => {
            this.setState({ createAsGlobal: value });
        }
        return (
            <FieldInstance label={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.CreateAsGlobal")} labelStyle={{ width: "50%" }}>
                <CheckBox {...props} />
            </FieldInstance>
        );
    }

    render() {
        return (
            <Dialog {...this.dialogProps} open={true} title={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.CreateNewFilter")}>
                {this.renderTextbox()}
                {Config.user.isSysAdmin ? this.renderCheckbox() : null}
            </Dialog >
        );
    }
}

interface FavoriteFilterManagerDialogProps {
    onOk: (name: string, createAsGlobal: boolean) => void;
    onClose: () => void;
    validateName: (name: string) => boolean
}